/**
 * description 融合编辑器-直播稿
 * created by he.zhikai
 * created on 2017-01-07
 */
'use strict';
angular.module('editFusionLiveModule', []).controller('editFusionLiveCtrl', [
    '$scope',
    'beforeonload',
    '$compile',
    '$controller',
    '$templateRequest',
    '$element',
    '$q',
    '$stateParams',
    '$state',
    '$window',
    'iWoBtnService',
    'iWoinitBtnService',
    'initeditctrBtnsService',
    'filterEditctrBtnsService',
    'editFusionEditorService',
    'modalDialog',
    'storageListenerService',
    'trsHttpService',
    'editcenterRightsService',
    'myManuscriptService',
    'editingCenterService',
    'editIsLock',
    'newMediaService',
    'messagePublishService',
    'iWoService',
    function(
        $scope,
        beforeonload,
        $compile,
        $controller,
        $templateRequest,
        $element,
        $q,
        $stateParams,
        $state,
        $window,
        iWoBtnService,
        iWoinitBtnService,
        initeditctrBtnsService,
        filterEditctrBtnsService,
        editFusionEditorService,
        modalDialog,
        storageListenerService,
        trsHttpService,
        editcenterRightsService,
        myManuscriptService,
        editingCenterService,
        editIsLock,
        newMediaService,
        messagePublishService,
        iWoService
    ) {
        var pagesInfo = {};
        $scope = iWoService.addFuture($scope, ['sendmessage']);
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.data = {
                navs: [], // 左侧导航
                errorNavs: [], // 保存出错的导航
            };
            $scope.status = {
                doctype: editFusionEditorService.getDoctypeByRouter($state.current.name), // 稿件类型
            };
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            // 编辑状态下请求绑定的渠道
            if (angular.isDefined($state.params.iwometadataid)) {
                editIsLock.lockDraft($state.params.iwometadataid);
                getBindingNavs().then(function(data) {
                    $scope.data.navs = data;
                    selectNav($scope.data.navs[0]);
                });
            } else {
                getRelatedNavs().then(function(data) {
                    $scope.data.navs = data;
                    selectNav($scope.data.navs[0]);
                });
            }
            initArrayBtn();
            $scope.handleBtnClick = function(funname) {
                eval('$scope.' + funname + '()');
            };
        }

        /**
         * [getBindingNavs description] 获取绑定的渠道信息
         * @return {[type]} [description]
         */
        function getBindingNavs() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_fusioncreate',
                methodname: 'queryFuseMappings',
                sourceDocId: $state.params.iwometadataid,
                mediaTypes: '',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                var navs = [];
                angular.forEach(data, function(value, key) {
                    value.routerName = editFusionEditorService.getRouterByMediatype(value.MEDIATYPE, $scope.status.doctype);
                    navs.push(value);
                });
                defer.resolve(navs);
            });
            return defer.promise;
        }

        /**
         * [getRelatedNavs description] 获取可以关联的渠道信息
         * @return {[type]} [description]
         */
        function getRelatedNavs() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_fusioncreate',
                methodname: 'getMediaTypesByDocType',
                doctype: $scope.status.doctype,
                sourceDocId: $scope.status.sourceDocId,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                var navs = [];
                angular.forEach(data, function(value, key) {
                    value.routerName = editFusionEditorService.getRouterByMediatype(value.MEDIATYPE, $scope.status.doctype);
                    navs.push(value);
                });
                defer.resolve(navs);
            });
            return defer.promise;
        }

        /**
         * [selectNav description] 选择导航
         * @param  {[type]} nav [description] 当前导航数据
         * @return {[type]}     [description]
         */
        function selectNav(nav) {
            var defer = $q.defer();
            $scope.data.selectedNav = nav;
            var navInfo = $state.get(nav.routerName).views[''];
            var templateUrl = navInfo.templateUrl;
            getTemplate(templateUrl, nav.routerName).then(function($template) {
                $element.find('.right').html($template);
                $template = $element
                    .find('.right')
                    .children()
                    .eq(0);
                var controller = {};
                controller.$scope = $scope.$new();
                controller.$element = $template;
                $controller(navInfo.controller, controller);
                $template = $compile($template)(controller.$scope);
                $scope.data.selectedNav.controller = controller;
                beforeonload.beforeonloadAlert($scope.data.selectedNav.controller.$scope);
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [getTemplate description] 获取模板
         * @param {string} [templateUrl] [description] 模板地址
         * @param {string} [pageName] [description] 模板名称
         * @return {[type]} [description]
         */
        function getTemplate(templateUrl, pageName) {
            var deffer = $q.defer();
            if (!!pagesInfo[pageName]) {
                deffer.resolve(pagesInfo[pageName].$template.clone());
                return deffer.promise;
            }
            $templateRequest(templateUrl).then(function(template) {
                var $dom = $(template);
                pagesInfo[pageName] = {
                    $template: $dom,
                };
                deffer.resolve(pagesInfo[pageName].$template.clone());
            });
            return deffer.promise;
        }

        /**
         * [initArrayBtn description] 初始化权限按钮
         * @return {[type]} [description]
         */
        function initArrayBtn() {
            var fromType = $state.params.fromType;
            if (fromType == 'departmentmanuscript') {
                $scope.iWoBtns = iWoinitBtnService.initBtnArrays()[2];
                initeditctrBtnsService.initDepartmentData($state.params.departmentaldocid).then(function(data) {
                    $scope.arrayBtn = filterEditctrBtnsService.filterBtn(data, $scope.iWoBtns);
                    addBtn();
                });
            } else {
                $scope.methodnameArray = ['iwo.personal', 'iwo.received'];
                $scope.dictionaryArray = [iWoBtnService.initIwoPersonBtn(), iWoBtnService.initIwoReceiveBtn()];
                $scope.iWoBtns = iWoinitBtnService.initBtnArrays()[$state.params.iwoplatform];
                initeditctrBtnsService.initIwoData($scope.methodnameArray[$state.params.iwoplatform]).then(function(data) {
                    initeditctrBtnsService.initBtns(data, $scope.dictionaryArray[$state.params.iwoplatform]).then((btns) => {
                        $scope.btnStatus = btns;
                        $scope.arrayBtn = filterEditctrBtnsService.filterBtn($scope.btnStatus, $scope.iWoBtns);
                        addBtn();
                    });
                });
            }
            // 获取查看痕迹按钮权限
            editcenterRightsService.initIwoListBtn('iwo.trace').then(function(data) {
                $scope.status.bigFaceRights = !!data['iwo.trace.chakan'] ? 'true' : 'false';
            });
        }

        /**
         * [addBtn description]新增按钮集合
         *
         * @return  {[type]}  [return description]
         */
        function addBtn() {
            $scope.arrayBtn.unshift({
                RIGHTINDEX: 'save',
                OPERDESC: '保存',
                OPERNAME: '保存',
                OPERFUN: 'save',
            });
            $scope.arrayBtn.push({
                RIGHTINDEX: 'savethenclose',
                OPERDESC: '保存并关闭',
                OPERNAME: '保存并关闭',
                OPERFUN: 'savethenclose'
            });
        }

        /**
         * [savethenclose description] 保存并关闭
         * @return {[type]} [description]
         */
        $scope.savethenclose = function () {
            $scope.status.saveType = false; // 保存类型，为undefined或true时，代表保存时要加锁
            editingCenterService.saveAndClose($scope.save);
        };

        /* 稿件操作开始*/
        /**
         * [save description] 保存稿件
         * @param {[type]} [flag] [description] 是否为操作前的保存
         * @return {[type]} [description]
         */
        $scope.save = function(flag) {
            var defer = $q.defer();
            // 涉密信息提示
            modalDialog.isSecretInformation(
                $state.params.iwometadataid,
                function() {
                    $scope.loadingPromise = saveDrafts($scope.data.navs[0]).then(function() {
                        // 保存成功后的处理
                        storageListenerService.addListenerToIwo('newsSaved');
                        // 保存结束刷新路由
                        // $state.params = angular.copy($stateParams);
                        $state.transitionTo($state.current, $stateParams, {
                            reload: false,
                        });
                        // 重新获取左侧导航
                        getBindingNavs().then(function(data) {
                            var tempNavsArray = [];
                            for (var i = 0; i < $scope.data.navs.length; i++) {
                                // 如果有保存失败的渠道，则在渠道上标记
                                for (var j = 0; j < $scope.data.errorNavs.length; j++) {
                                    if ($scope.data.navs[i].MEDIATYPE == $scope.data.errorNavs[j].MEDIATYPE) {
                                        $scope.data.navs[i].hasError = true;
                                    }
                                }
                                // 如果新添加的渠道并没有被保存成功，那么暂时先保留该渠道
                                var hasNav = false;
                                for (var k = 0; k < data.length; k++) {
                                    if (data[k].MEDIATYPE == $scope.data.navs[i].MEDIATYPE) {
                                        data[k].controller = $scope.data.navs[i].controller;
                                        data[k].list = $scope.data.navs[i].list;
                                        data[k].list.hasError = $scope.data.navs[i].hasError;
                                        tempNavsArray.push(data[k]);
                                        hasNav = true;
                                    }
                                }
                                if (!hasNav) {
                                    tempNavsArray.push($scope.data.navs[i]);
                                }
                            }
                            $scope.data.navs = tempNavsArray;
                            $scope.data.errorNavs = [];
                            // 如果当前渠道已被新对象替换，则重新对其进行绑定
                            for (var l = 0; l < $scope.data.navs.length; l++) {
                                if ($scope.data.selectedNav.MEDIATYPE == $scope.data.navs[l].MEDIATYPE) {
                                    $scope.data.selectedNav = $scope.data.navs[l];
                                    break;
                                }
                            }
                        });
                        // 所有页面均无错误时，提示保存成功
                        if ($scope.data.errorNavs.length === 0) {
                            if (!flag) {
                                modalDialog.saveModel('保存成功', '', 'success');
                            }
                            defer.resolve();
                        }
                    });
                },
                function() {
                    defer.reject();
                }
            );
            return defer.promise;

            /**
             * [saveDrafts description] 保存稿件方法
             * @param  {[type]} nav [description] 稿件渠道
             * @return {[type]}     [description]
             */
            function saveDrafts(nav) {
                var defer = $q.defer();
                saveDraftsByNavs(
                    nav,
                    function() {
                        defer.resolve();
                    },
                    function() {
                        defer.reject();
                    }
                );
                return defer.promise;
            }

            /**
             * [saveDraftsByNavs description] 分渠道保存稿件
             * @param  {[type]} nav     [description] 稿件渠道
             * @param  {[type]} success [description] 全部保存成功回调
             * @param  {[type]} error   [description] 保存失败回调
             * @return {[type]}         [description]
             */
            function saveDraftsByNavs(nav, success, error) {
                // 直接调编辑页控制器内的保存方法
                nav.controller.$scope.save().then(
                    function() {
                        $state.params.iwochnldocid = angular.isDefined($state.params.iwochnldocid)
                            ? $state.params.iwochnldocid
                            : nav.controller.$scope.data.iwochnldocid;
                        $state.params.iwometadataid = angular.isDefined($state.params.iwometadataid)
                            ? $state.params.iwometadataid
                            : nav.controller.$scope.data.iwometadataid;
                        $state.params.appchnldocid = angular.isDefined($state.params.appchnldocid)
                            ? $state.params.appchnldocid
                            : nav.controller.$scope.list.CHNLDOCID;
                        $state.params.appmetadataid = angular.isDefined($state.params.appmetadataid)
                            ? $state.params.appmetadataid
                            : nav.controller.$scope.list.METADATAID;
                        success();
                        delete nav.hasError;
                    },
                    function() {
                        error();
                    }
                );
            }
        };

        /**
         * [iWoSubmit description] 稿件提交
         * @return {[type]} [description]
         */
        $scope.iWoSubmit = function() {
            let methodname = ['PersonalSubmitDoc', 'ReceivedSubmitDoc', 'submit'];
          
            $scope.status.saveType = false; // 保存类型，为undefined或true时，代表保存时要加锁
            $scope.save(true).then(function () { // 提交放在保存后是因为提交内逻辑是需要实体稿件信息才能执行
                if ($state.params.departmentaldocid){ // 部门稿库需要加锁
                    editIsLock.lockDraft($state.params.iwometadataid);   
                }
                $scope.submitList = [{
                    CHNLDOCID: $state.params.iwochnldocid,
                    METADATAID: $state.params.iwometadataid,
                    DOCTYPEID: editFusionEditorService.getDoctypeByRouter($state.current.name),
                }];
                newMediaService.iwoSubmit($scope, methodname[$state.params.iwoplatform]);
            });
        };


        /**
         * [iWoshare description] 部门提交
         * @return {[type]} [description]
         */
        $scope.departmentSubmit = function() {
            $scope.status.saveType = false; // 保存类型，为undefined或true时，代表保存时要加锁
            $scope.save(true).then(function() {
                editIsLock.lockDraft($state.params.iwometadataid);
                departmentSubmit();
            });
        };

        /**
         * [departmentSubmit description] 部门提交
         * @return {[type]} [description]
         */
        function departmentSubmit() {
            editFusionEditorService.departmentSubmit($scope);
        }

        /**
         * [iWoshare description] 稿件共享
         * @return {[type]} [description]
         */
        $scope.iWoshare = function() {
            $scope.status.saveType = false; // 保存类型，为undefined或true时，代表保存时要加锁
            newMediaService.iwoShare($scope).then((shareObj) => {
                $scope.save(true).then(function () {
                    messagePublishService.publish('doEditPageOperation', iWoService.packageShareParams(shareObj));
                });
            });
        };


        /**
         * [iWoTransfer description] 稿件传稿
         * @return {[type]} [description]
         */
        $scope.iWoTransfer = function() {
            $scope.save(true).then(function() {
                draft();
            });
        };

        /**
         * [draft description] 稿件传稿方法
         * @return {[type]} [description]
         */
        function draft() {
            editIsLock.normalLock($state.params.iwometadataid).then(function() {
                var iwoData = [
                    {
                        CHNLDOCID: $state.params.iwochnldocid,
                        METADATAID: $state.params.iwometadataid,
                    },
                ];
                var menthod = ['personalTransferMetaDatas', 'receivedTransferMetaDatas'];
                myManuscriptService.draft(
                    '传稿',
                    iwoData,
                    function() {
                        storageListenerService.addListenerToIwo('newsPassed');
                        var opened = $window.open('about:blank', '_self');
                        opened.close();
                    },
                    function() {},
                    menthod[$state.params.iwoplatform]
                );
            });
        }

        /* 稿件操作结束*/
    },
]);
